"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeInputStyles = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var makeInputStyles = function makeInputStyles(_ref) {
  var primitives = _ref.primitives,
      tokens = _ref.tokens;
  return {
    MuiInput: {
      styleOverrides: {
        root: {
          fontWeight: primitives.fontWeights.stout
        },
        input: {
          "&::placeholder": {
            fontWeight: primitives.fontWeights.default
          }
        },
        underline: {
          '&[class*="MuiInputBase-root"]': _objectSpread(_objectSpread({
            boxShadow: tokens.effects["field-default"].boxShadow,
            color: tokens.colors["ink-on-background"].rgb
          }, tokens.transitions["state-activate"]), {}, {
            marginTop: primitives.spacings["0"],
            padding: primitives.spacings["0"],
            "&:before": _objectSpread({
              height: "100%"
            }, tokens.transitions["state-activate"]),
            "&:after": {
              borderBottom: "".concat(primitives.borderWidths.medium, " solid ").concat(tokens.colors["fill-primary"].rgb)
            },
            "&.Mui-error:before": {
              borderBottomWidth: primitives.borderWidths.none
            },
            "&.Mui-error:after": {
              borderBottomWidth: primitives.borderWidths.none
            },
            "&.Mui-disabled": {
              opacity: tokens.colors["background-40"].opacity,
              pointerEvents: "none"
            },
            "&:hover": _objectSpread(_objectSpread(_objectSpread({}, tokens.effects["field-default"]), tokens.transitions["state-blur"]), {}, {
              '&[class*="MuiFilledInput-underline"]': {
                boxShadow: "none"
              }
            }),
            "&:hover:not(.Mui-disabled):before": {
              borderBottomWidth: primitives.borderWidths.none,
              boxShadow: "0px 1px 0px 0px ".concat(tokens.colors["ink-hover"].color)
            },
            "&.Mui-error, &.Mui-error:hover, &.Mui-focused.Mui-error": _objectSpread(_objectSpread({}, tokens.effects["field-error"]), {}, {
              '&[class*="MuiFilledInput-underline"]': {
                boxShadow: "none"
              }
            }),
            "&.Mui-error:hover:not(.Mui-disabled):before": {
              boxShadow: "0px 1px 0px 0px ".concat(primitives.colors.accent.clay)
            },
            "&.Mui-focused, &:focus, &:focus-visible": {
              boxShadow: "0px 1px 0px 0px ".concat(tokens.colors["text-link-loud"].rgb, " inset, 0px 0px 0px 1px ").concat(tokens.colors["text-link-loud"].rgb, " inset"),
              outline: "none",
              '&[class*="MuiFilledInput-underline"]': {
                boxShadow: "none"
              }
            },
            "&.Mui-focused:not(.Mui-disabled):before, &:focus:not(.Mui-disabled):before, &:focus-visible:not(.Mui-disabled):before": {
              borderBottomWidth: primitives.borderWidths.none,
              boxShadow: "0px 0px 0px 1px ".concat(primitives.colors.accent.iris, ", 0px 0px 0px 1px ").concat(primitives.colors.primary.black)
            },
            "&.Mui-error.Mui-focused:not(.Mui-disabled):before, &.Mui-error:focus:not(.Mui-disabled):before, &.Mui-error:focus-visible:not(.Mui-disabled):before": {
              borderBottomWidth: primitives.borderWidths.none,
              boxShadow: tokens.effects["field-error"].boxShadow
            },
            '& + .DhigTextInput--count + [class*="MuiFormHelperText-root"]': {
              marginTop: "-".concat(primitives.spacings[6]),
              paddingRight: primitives.spacings[9]
            },
            "& + .DhigTextInput--count + .Mui-error": {
              position: "relative",
              paddingLeft: primitives.spacings[5],
              '& [class*="MuiSvgIcon-root"]': {
                position: "absolute",
                left: "0px"
              }
            },
            "& + .Mui-error": {
              position: "relative",
              paddingLeft: primitives.spacings[5],
              "& [class*='MuiSvgIcon-root']": {
                position: "absolute",
                left: "0px"
              }
            },
            '& [class*="MuiSelect-icon"]': {
              color: "inherit",
              marginRight: primitives.spacings["1"],
              top: "30%"
            },
            // eslint-disable-next-line no-warning-comments
            // todo: these styles are too general
            '& [class*="MuiInputAdornment-root"]': {
              width: primitives.spacings["7"],
              justifyContent: "center",
              paddingLeft: primitives.spacings["1"],
              paddingRight: primitives.spacings["1"],
              "button svg[class*='MuiSvgIcon-root']": {
                width: primitives.spacings["5"],
                height: primitives.spacings["5"],
                color: tokens.colors["fill-primary"].rgb
              },
              '&[class*="MuiInputAdornment-positionStart"]': {
                marginRight: primitives.spacings["1"]
              },
              '&[class*="MuiInputAdornment-positionEnd"]': {
                marginLeft: primitives.spacings["1"]
              }
            },
            '&[class*="MuiInputBase-multiline"]': {
              padding: primitives.spacings["0"]
            },
            '& [class*="MuiInputBase-input"]': _objectSpread(_objectSpread({
              padding: "".concat(primitives.spacings["2"], " ").concat(primitives.spacings["4"], " ").concat(primitives.spacings["2"], " ").concat(primitives.spacings["3"]),
              color: tokens.colors["ink-on-background"].rgb,
              height: primitives.spacings["6"]
            }, tokens.typography["input-value"]), {}, {
              '&[class*="MuiInputBase-inputMultiline"]': {
                padding: "".concat(primitives.spacings["3"], " ").concat(primitives.spacings["3"], " ").concat(primitives.spacings["0"], " ").concat(primitives.spacings["3"], " ")
              },
              '&[class*="MuiInputBase-inputAdornedStart"]': {
                paddingLeft: primitives.spacings["0"],
                marginLeft: "-".concat(primitives.spacings["2"])
              },
              '&[class*="MuiInputBase-inputAdornedEnd"]': {
                paddingRight: primitives.spacings["0"],
                marginRight: "-".concat(primitives.spacings["2"])
              }
            })
          })
        }
      }
    }
  };
};

exports.makeInputStyles = makeInputStyles;